import React from 'react'

/**
 * Signal from a UI2 form section to its descendant field shells asking them to
 * paint their `is required` errors even before the outer entity has been
 * submitted. Sections flip this true when the user attempts to advance while
 * required fields are still empty (submit-mode) or immediately on becoming the
 * active wizard step (automatic-mode). Defaults to false, matching legacy
 * behavior — field shells only glow red once the parent entity flips
 * `hasSubmitted`.
 */
export const UI2FormSectionSubmitContext = React.createContext<boolean>(false)
